import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Type } from '@spotify-internal/encore-creator-web';
import tokens from '@spotify-internal/encore-foundation';
import { formatDate } from 'lib/Formatter';
import { LOADING, ERROR } from 'store/selectors';

const PodcastPendingContainer = styled.div`
  display: block;
  margin-bottom: ${tokens.spacer16};
`;

const PodcastArtwork = styled.img`
  height: 220px;
  width: 220px;
  margin-right: ${tokens.spacer32};
`;

const PodcastInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

const Status = styled.div`
  display: flex;
  align-items: center;
  & > p {
    margin-right: 5px;
  }
`;

const PodcastRow = styled.div`
  display: flex;
  margin-bottom: ${tokens.spacer48};
`;

const PodcastName = styled(Type.h1)`
  width: 500px;
  line-height: 28px;
`;
export class PodcastPending extends PureComponent {
  static propTypes = {
    pendingPodcasts: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        artworkUrl: PropTypes.string,
        name: PropTypes.string,
        publisher: PropTypes.string,
        submissionTime: PropTypes.string,
      }),
    ),
    pendingPodcastsStatus: PropTypes.oneOf([LOADING, ERROR]),
  };

  get podcastRows() {
    return this.props.pendingPodcasts.map(podcast => (
      <PodcastRow key={podcast.id}>
        <PodcastArtwork src={podcast.artworkUrl} alt="podcast-artwork" data-qa="podcast-artwork" />
        <PodcastInfo data-qa="podcast-info">
          <PodcastName variant={Type.heading3} condensed>
            {podcast.name}
          </PodcastName>
          <Type as="p" condensed variant={Type.sm} color="gray60">
            By {podcast.publisher}
          </Type>
          <Status>
            <Type as="p" variant={Type.sm} color="azure">
              Processing
            </Type>
            <Fragment>
              <Type as="p" variant={Type.xs} color="gray60">
                •
              </Type>
              <Type as="p" variant={Type.sm} color="gray60">
                Submitted on {formatDate(podcast.submissionTime, 'MMMM D YYYY', false)}
              </Type>
            </Fragment>
          </Status>
        </PodcastInfo>
      </PodcastRow>
    ));
  }

  render() {
    switch (this.props.pendingPodcastsStatus) {
      case ERROR:
        return <span data-qa="podcast-pending-error" />;
      default:
        break;
    }
    return (
      <PodcastPendingContainer data-qa="podcast-pending">
        <Type as="h1" variant={Type.heading2}>
          Your podcasts
        </Type>
        {this.podcastRows}
      </PodcastPendingContainer>
    );
  }
}
